import { useSetRemovedDefaultBuyingTeam } from '@aibees/elephant/feature/buying-team-matrix/hooks/use-remove-buying-team-preset';
import { useDeletePresetMutationApi } from '@aibees/shared/api';
import { Icon } from '@aibees/shared/components';
import { Preset } from '@aibees/shared/definition';
import { useNotify } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PresetDeleteActionDialogProps as Props } from './types';

export const PresetDeleteActionDialog = memo(
  ({ className, state, item, presetTitle, onSuccess }: Props) => {
    const notify = useNotify();
    const api = useDeletePresetMutationApi(item.id);
    const setRemovedDefaultBuyingTeam = useSetRemovedDefaultBuyingTeam(
      item as Preset
    );

    const handleDelete = () => {
      api.mutateAsync({}).then(() => {
        notify.success('Item Deleted Successfully!');
        state.onFalse();
        onSuccess?.();
        if (item.value.default) setRemovedDefaultBuyingTeam();
      });
    };

    return (
      <Styled.Wrapper
        state={state}
        className={classnames('PresetDeleteActionDialog', className)}
        sx={SX.root}
        contentSx={{ p: 0, backgroundColor: (p) => p.palette.common.white }}
      >
        <Stack direction="column" alignItems="center" justifyContent="center">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="start"
            gap={1}
            sx={SX.header}
          >
            <Icon name="delete" sxx={SX.icon} size={20} />
            <Typography sx={SX.title}>Delete {presetTitle}</Typography>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={SX.content}
          >
            <Typography sx={SX.text}>
              Are you sure you want to delete “<b>{item.name}</b>”?
            </Typography>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            gap={1}
            sx={SX.footer}
          >
            <Button onClick={state?.onFalse}>Cancel</Button>

            <Button
              onClick={handleDelete}
              sx={SX.button}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </Stack>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

PresetDeleteActionDialog.displayName = 'PresetDeleteActionDialog';
